import { normalizeArrayQueryParam, normalizeQueryArrays } from '@/composables/queryParams'

export const buildProductsSearchQuery = (params) =>
    normalizeQueryArrays(
        {
            q: params.q,
            property_id: params.propertyId,
            location_id: params.locationId,
            region_id: params.regionId,
            region_group_id: params.regionGroupId,
            start_date: params.startDate,
            nights: params.nights,
            adults: params.adults,
            children: params.children
        },
        ['children']
    )

// For the catalog SEO listing path (/nastanitve/{regionGroup}[/{region}[/{location}[/{property}]]]):
// the geography is already encoded in the path, so only booking-context
// params ride along in the query string.
export const buildCatalogListingQuery = (params) =>
    normalizeQueryArrays(
        {
            start_date: params.startDate,
            nights: params.nights,
            adults: params.adults,
            children: params.children
        },
        ['children']
    )

export const pickProductContextQuery = (query = {}) => ({
    start_date: query.start_date,
    nights: query.nights,
    adults: query.adults,
    children: normalizeArrayQueryParam(query.children)
})
